import React from "react";
import { TimestampToDateMoment } from "../../../../../utils/timestampToDate";
import { Alert } from "@material-ui/lab";
import PageSpinner from "../../../../elements/spinner/PageSpinner";
import { NavLink } from "react-router-dom";

import {
  StyledCol,
  StyledScrollTable,
  StyledTable,
  StyledTableBody,
  StyledTableHead,
  StyledTableRow
} from "../../../../styles/styledTable";

const ProjectConnectionsList = ({ t, connections }) => {

  if (!connections) {
    return <PageSpinner position="center" pt="20" pb="20" />;
  }

  if (connections.length === 0) {
    return <Alert severity="warning">{t("details.connections.table.emptyData")}</Alert>;
  }

  return (
    <StyledScrollTable>
      <StyledTable
        width="1070"
        size="14"
        className="projects-connection-table"
      >
        <StyledTableHead
          scroll="auto"
          col="5"
          className="projects-connection-table__head"
        >
          <div>
            {t("details.connections.table.service")}
          </div>
          <div>
            UUID
          </div>
          <div>
            {t("details.connections.table.payment")}
          </div>
          <div>
            {t("details.connections.table.payout")}
          </div>
          <div>
            {t("details.connections.table.date")}
          </div>
        </StyledTableHead>
        <StyledTableBody>
          {connections && connections.map((value, key) => (
            <StyledTableRow
              key={key}
              scroll="auto"
              col="5"
              className="projects-connection-table__row"
            >
              <StyledCol>
                <NavLink to={`/services/${value.service.id}`}>
                  {value.service.name}
                </NavLink>
              </StyledCol>
              <StyledCol>
                {value.id}
              </StyledCol>
              <StyledCol>
                {value.enablePayment ? t("details.connections.table.enable") : t("details.connections.table.disable")}
              </StyledCol>
              <StyledCol>
                {value.enablePayout ? t("details.connections.table.enable") : t("details.connections.table.disable")}
              </StyledCol>
              <StyledCol>
                {TimestampToDateMoment(value.createDate)}
              </StyledCol>
            </StyledTableRow>
          ))}
        </StyledTableBody>
      </StyledTable>
    </StyledScrollTable>
  );
};

export default ProjectConnectionsList;